  <template>
  <v-container fluid>
        <v-card>
          <v-toolbar dense flat >
            <v-btn v-show="mode === 'page'" @click="$router.go(-1)" icon light>
              <v-icon>chevron_left</v-icon>
            </v-btn>
            <v-toolbar-title>{{loner.name.caption}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        <v-card-scroll v-show="loner && loner.ogrnip" md flat :offset="calcOffset(60, 60)">
          <v-layout row wrap>
            <v-flex>
          <v-card>
            <v-card-text>
              <v-layout row>
               <v-component :is="renderCompanyFlags()" />
              <v-layout justify-end row wrap>
              <v-chip
                v-for="tag in tags"
                :key = tag.id
                small
                disabled
                text-color="secondary"
                @click="editNotesDialogOpen()"
                >
                <span class="text-xs-center">
                {{tag.name}}
                </span>
              </v-chip>
              </v-layout>
              </v-layout>

              <component :is="createNameComp(loner)"/>
              <component :is="createNameShortComp(loner)"/>
              <div>Дата создания: <b>{{formatDate(loner.createDate)}}</b></div>

              <span v-html="formatStatus(loner.status)"></span>
              <div>
                ОГРНИП <b v-html="loner.ogrnip"></b>
                <v-component :is="renderCopyButton('Копировать огрнип', getCompanyOgrnIp)" />
                ИНН <b v-html="renderInnflHtml(loner.inn)"></b>
                <v-component :is="renderCopyButton('Копировать инн', getCompanyInn)" />
              </div>
              <div>
              </div>
              <div>
              Основной вид деятельности: <b><span v-html="renderFirstActivityHtml(loner.activities)"></span></b>
              </div>

              <!-- <div v-html="formatTaxMode(loner.taxMode)"></div> -->
              <component :is="createEmailComp(loner)"/>
              <component :is="createHeadsComp(loner.heads)"/>

              <div v-show="notesAvailable"><br/>
                <a @click="editNotesDialogOpen()">{{notes ? 'Примечания:' : 'Внесите корпоративные заметки (они будут видны Вашим коллегам).'}}</a>
                <div style="white-space: pre-wrap; overflow-wrap: break-word;" v-html="notes"></div>
              </div>
              <div v-show="notesAvailable">
                <v-layout justify-begin row wrap>
                <v-chip
                  small
                  disabled
                  text-color="secondary"
                  @click="goDepo()"
                  >
                  <v-tooltip bottom open-delay="500">
                    <span slot="activator">
                     <v-icon>storage</v-icon>
                    </span>
                    <span>Перейти в депозитарий</span>
                  </v-tooltip></span>
                </v-chip>
                </v-layout>
              </div>
              <div v-show="notesAvailable"><br/>
                <a @click="editNotesDialogOpen()">{{privateNotes ? 'Личные заметки:' : 'Внесите личные заметки (они будут видны только Вам).'}}</a>
                <span style="white-space: pre-wrap; overflow-wrap: break-word;" v-html="privateNotes"></span>
              </div>

          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 v-if="loner && loner.reference && loner.reference.ref && clientCompanyId != null">
        <v-contacts-panel fill-height :refCode="loner.reference.ref"></v-contacts-panel>
      </v-flex>
      <v-flex xs12 sm6 v-if="loner && loner.reference && loner.reference.ref && clientCompanyId != null">  
        <v-banks-panel fill-height :banks="banks"></v-banks-panel>
      </v-flex>
      <v-flex xs12 sm6>
        <v-activities-panel fill-height v-show="loner && loner.reference " :activities="loner.activities"></v-activities-panel>
      </v-flex>            
      <v-flex xs12 sm6>
       <v-credentinals-panel fill-height v-show="loner && (loner.tax || loner.pf || loner.fss || loner.registration)" :reg="loner.registration" :tax="loner.tax" :pf="loner.pf" :fss="loner.fss"></v-credentinals-panel>
      </v-flex>
      <v-flex xs12 sm6>
        <v-loner-licenses-panel fill-height v-show="loner && loner.reference " :items="loner.licenses"></v-loner-licenses-panel>
      </v-flex>      
      <v-flex sm6>
        <v-visit-panel fill-height v-if="loner && loner.reference && loner.reference.ref && getProfileHaveClient" :topCount="5" :refCode="loner.reference.ref"></v-visit-panel>
      </v-flex>
      <v-flex xs12 sm6>
        <v-loner-records-panel fill-height v-show="loner && loner.reference " :records="loner.records"></v-loner-records-panel>
      </v-flex>      
      <v-flex xs12 sm6 >
        <v-links-panel fill-height v-show="loner && loner.ogrnip" :inn="loner.ogrnip" ></v-links-panel>
      </v-flex>
      </v-layout>
      </v-card-scroll>
          <v-card-actions>
            <v-layout row wrap>
<!--               <v-flex py-1 v-show="company && company.inn && !company.clientId && !this.accountNameShort">
                <v-component :is="createButton('Приглашение', 'mail_outline', 'Пригласить в Систему АТЛАНТ-СМАРТ', invite)" />
              </v-flex>
 -->
              <v-flex py-1 v-if="loner && loner.reference">
                <v-component :is="createButton('Ссылка', 'content_copy', 'Копировать ссылку в буфер обмена', copyLink)" />
              </v-flex>
              <v-flex py-1 v-if="loner && loner.reference && getProfileHaveClient && !favoriteLists && !this.accountNameShort">
                <v-component :is="createButton('Контрагент', 'add_circle_outline', 'Добавить контрагента в Мои контрагенты', addFavorite)" />
              </v-flex>
              <v-flex py-1 v-if="loner && loner.reference && getProfileHaveClient && favoriteLists && !this.accountNameShort">
                <v-component :is="createButton('Атрибуты', 'info_outline', 'Атрибуты котрагента в Моих контрагентах', editNotesDialogOpen)" />
              </v-flex>
            </v-layout>
          </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import server from '../../api/server'
  import formats from '../../api/formats'
  import dialogs from '../common/dialogs'
  import people from '../people/index.js'
  import vCardScroll from '../common/CardScroll'
  import vNotesForm from './NotesForm'
  import vVisitPanel from './VisitPanel'
  import vClientPreviewPanel from './ClientPreviewPanel'
  import vCredentinalsPanel from '../info/CredentinalsPanel'
  import vContactsPanel from '../info/ContactsPanel'
  import vBanksPanel from '../info/BanksPanel'
  import vActivitiesPanel from './ActivitiesPanel'
  import vLinksPanel from '../info/LinksPanel'
  import vLonerLicensesPanel from '../info/LonerLicensesPanel'
  import vLonerRecordsPanel from '../info/LonerRecordsPanel'

  export default {
    name: 'loner-page',
    components: {vCardScroll, vVisitPanel, vClientPreviewPanel, vCredentinalsPanel, vContactsPanel, vBanksPanel, vActivitiesPanel, vLinksPanel, vLonerLicensesPanel, vLonerRecordsPanel},
    data: () => ({
      showAllCompanies: false,
      loner: null,
      clientCompanyId: null,
      banks: [],
      favoriteLists: null,
      privateNotes: null,
      notes: null,
      tags: null,
      accountNameShort: null,
      otherAttribs: []
    }),
    props: {
      itemId: {
        type: String,
        default: null
      },
      fullscreen: {
        type: Boolean,
        default: false
      },
      mode: {
        type: String,
        default: 'page'
      },
      notesAvailable: {
        type: Boolean,
        default: true
      },
      notesEditable: {
        type: Boolean,
        default: true
      }
    },
    created () {
      this.initLoner()
    },
    mounted () {
      if (this.itemId) {
        this.fetchLonerProps(this.itemId)
      }
    },
    watch: {
      itemId: function (newVal, oldVal) { // watch it
        if (newVal) {
          this.fetchLonerProps(newVal)
        } else {

        }
      },
      getProfileHaveClient: function (newVal, oldVal) { // watch it
        this.refreshCompanyProps()
      }
    },
    computed: {
      ...mapGetters({
        getProfileHaveClient: 'getProfileHaveClient',
        getClientUrl: 'getClientUrl',
        getRefToUrl: 'getRefToUrl',
        renderEmployeeReference: 'renderEmployeeReference',
        renderReference: 'renderReference',
        renderInnHtml: 'renderInnHtml',
        renderInnflHtml: 'renderInnflHtml',
        renderDateSince: 'renderDateSince',
        renderStatus: 'renderStatus',
        renderFlags: 'renderFlags',
        renderFirstActivityHtml: 'renderFirstActivityHtml',
        renderUnreliableHtml: 'renderUnreliableHtml',
        getIconName: 'getIconName',
        getEmailHeaderReport: 'getEmailHeaderReport',
        getAgreementHeader1Report: 'getAgreementHeader1Report',
        getAgreementHeader2Report: 'getAgreementHeader2Report',
        getAgreementFooterReport: 'getAgreementFooterReport',
        getClientEnvelopeReport: 'getClientEnvelopeReport',
        renderCopyButton: 'renderCopyButton',
        renderContactButton: 'renderContactButton',
        calcDialogOfs: 'calcDialogOfs',
        calcOfs: 'calcOfs'
      })
    },
    methods: {
      calcOffset (off, offModal) {
        return this.calcOfs(off, offModal)
      },
      formatDate (dateTime) {
        return formats.blank(dateTime, formats.formatDate)
      },
      createNameComp (loner) {
        var self = this
        var template = ''.concat(
          `<div>
            <div>
              <b><span v-html="getDto()"></span></b>
              {{self.renderDateSince(dto)}}
               <v-component :is="self.renderCopyButton('Копировать название', self.getCompanyNameFull)" />
            </div>
            <div>
             <span v-html="self.renderUnreliableHtml(dto)"></span>
            </div>
           </div>`
        )
        return {
          template: template,
          data: function () {
            return {
              self: self,
              loner: loner,
              dto: loner.name,
              formats: formats
            }
          },
          methods: {
            getDto () {
              return this.dto && this.dto.value ? this.dto.value : formats.formatWarningHtml('ЕГРЮЛ не содержит запись о названии компании')
            }
          }
        }
      },
      createNameShortComp (loner) {
        var self = this
        var template = ''.concat(
          `<div>
            <div>
              Сокращенное название: <b><span v-html="getDto()"></span></b>
               <v-component :is="self.renderCopyButton('Копировать название', self.getCompanyNameShort)" />
            </div>
           </div>`
        )
        return {
          template: template,
          data: function () {
            return {
              self: self,
              loner: loner,
              dto: loner.name.nameShort,
              formats: formats
            }
          },
          methods: {
            getDto () {
              return this.dto ? this.dto : '-'
            }
          }
        }
      },
      formatStatus (status) {
        return ''.concat(
          '<div>',
          'Статус в ЕГРИП: ',
          this.renderStatus(status),
          '</div>'
          )
      },
      createEmailComp (loner) {
        var self = this
        var template = ''.concat(
          `<div>
            <div>
              Адрес эл. почты: <b><span v-html="getDto()"></span></b>
              {{self.renderDateSince(dto)}}
              <v-component :is="self.renderCopyButton('Копировать адрес эл. почты', self.getCompanyAddress)" />
            </div>
           </div>`
        )
        return {
          template: template,
          data: function () {
            return {
              self: self,
              company: loner,
              dto: loner.email,
              formats: formats
            }
          },
          methods: {
            getDto () {
              return this.dto && this.dto.value ? this.dto.value : formats.formatWarningHtml('ЕГРИП не содержит запись об адресе эл. почты')
            }
          }
        }
      },
      createHeadsComp (heads) {
        var self = this
        var template = `
        <div>
          <b v-if="!heads || heads.length === 0">${formats.formatWarningHtml('ЕГРЮЛ не содержит запись о руководителе компании')}</b>
          <template v-for="head in heads">
            <v-component :is="self.createEmployeeComp(head)"/>
          </template>
        </div>
        `
        return {
          template: template,
          data: function () {
            return {
              self: self,
              heads: heads
            }
          }
        }
      },
      createEmployeeComp (employee) {
        var self = this
        var template = `
        <div>
        <span v-html="self.renderEmployeeReference(employee)"></span>
        <b> ${self.formatHumanCountersHtml(employee.counters)} </b> 
        <v-component :is="self.renderCopyButton('Копировать ФИО', getNameFull)" />` +
        `
        <v-component :is="self.renderContactButton('Открыть контакт физического лица', openContact)" />
        ` +
        `
          <div>
            ИНН ${self.renderInnflHtml(employee.inn)}
            <v-component :is="self.renderCopyButton('Копировать ИНН', getInn)" />
          </div>
        </div>
        `
        return {
          template: template,
          data: function () {
            return {
              self: self,
              employee: employee
            }
          },
          methods: {
            getPosition () {
              return self.getCompanyEmployeePosition(employee)
            },
            getNameFull () {
              return self.getCompanyEmployeeNameFull(employee)
            },
            getInn () {
              return self.getCompanyEmployeeInn(employee)
            },
            openContact () {
              let refCode = formats.getValue(self.loner, ['reference', 'ref'])
              people.openByHuman(refCode, employee)
            }
          }
        }
      },
      formatHumanCountersHtml (counters) {
        const _f = v => v !== null ? v : 'нет данных'
        if (!counters) {
          return '<div></div>'
        }
        var result = ''.concat(
          `<v-tooltip bottom>`,
          `<span slot="activator">`,
          `<v-icon small>${this.getIconName('head')}</v-icon>${_f(counters.managedCompaniesExact)}(${_f(counters.managedCompaniesGeneral)})&nbsp`,
          `<v-icon small>${this.getIconName('holder')}</v-icon>${_f(counters.sharedCompaniesExact)}(${_f(counters.sharedCompaniesGeneral)})&nbsp`,
          `<v-icon small>${this.getIconName('loner')}</v-icon>${_f(counters.loners)}`,
          `</span>`,
          `<span>Управление и участие в компаниях, наличие ИП <br/> точное (не точное) совпадение</span>`,
          `</v-tooltip>`
          )
        return result
      },
      createCopyButton (caption, icon, hint, action) {
        var template = ''.concat(
          `<div><v-tooltip bottom open-delay="500">
            <div slot="activator">
              <v-btn  small flat  @click="self.copyToClipboard(action)">
                <v-icon small>{{icon}}</v-icon>{{caption}}
              </v-btn>
            </div>
            <span>{{hint}}</span>
          </v-tooltip></div>`
        )
        var self = this
        return {
          template: template,
          data: function () {
            return {
              caption: caption,
              icon: icon,
              hint: hint,
              action: action,
              self: self
            }
          }
        }
      },
      getCompanyNameFull () {
        return `${formats.getValue(this.loner, ['name', 'value'])}`
      },
      getCompanyNameShort () {
        return `${formats.getValue(this.loner, ['name', 'nameShort'])}`
      },
      getCompanyOgrnIp () {
        return `${formats.getValue(this.loner, ['ogrnip'])}`
      },
      getCompanyInn () {
        return `${formats.formatInn(formats.getValue(this.loner, ['inn']))}`
      },
      getCompanyKpp () {
        return `${formats.getValue(this.loner, ['kpp'])}`
      },
      getCompanyAddress () {
        return `${formats.getValue(this.loner, ['email', 'value'])}`
      },
      getCompanyEmployeePosition (employee) {
        console.log('getCompanyEmployeePosition', employee)
        return `${formats.getValue(employee, ['position'])}`
      },
      getCompanyEmployeeNameFull (employee) {
        return `${formats.getValue(employee, ['nameFull'])}`
      },
      getCompanyEmployeeInn (employee) {
        return `${formats.formatInnfl(formats.getValue(employee, ['inn']))}`
      },
      getLonerProps (id, cb) {
        const cbError = (e) => {
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации о индивидуальных предпринимателях из ЕГРИП '})
        }
        server.openApiGet(
          '/openapi/loners/' + id,
          cb,
          cbError)
      },
      fetchLonerProps (id) {
        this.initLoner()
        this.getLonerProps(id, (data) => {
          this.loner = data
          this.fetchFavoriteProps(id)
        })
      },
      initLoner () {
        this.loner = {
          id: null,
          inn: null,
          nameShort: '',
          name: ''
        }
      },
      fetchFavoriteProps (inn) {
        this.$store.dispatch('getFavoriteRefs', 'ogrnip:' + inn).then((data) => {
          console.log('fetchLonerProps', data)
          if (!Array.isArray(data) || data.length < 1) {
            console.log('fetchLonerProps', data)
            return
          }
          if (this.getProfileHaveClient) {
            this.clientCompanyId = data[0].clientCompanyId
            this.banks = data[0].banks
            this.favoriteLists = data[0].tags
            this.privateNotes = data[0].privateNotes
            this.notes = data[0].notes
            this.tags = data[0].tags
            this.monitoring = data[0].monitoring
            this.accountNameShort = data[0].accountNameShort
            this.otherAttribs = data.slice(1)
          } else {
            this.clientCompanyId = null
            this.banks = []
            this.favoriteLists = null
            this.privateNotes = null
            this.notes = null
            this.tags = null
            this.monitoring = false
            this.accountNameShort = null
            this.otherAttribs = []
          }
        })
      },
      refreshCompanyProps () {
        if (this.itemId) {
          this.fetchLonerProps(this.itemId)
        }
      },
      copyLink () {
        let refCode = formats.getValue(this.loner, ['reference', 'ref'])
        this.$store.dispatch('copyCompanyLink', this.getClientUrl(refCode))
      },
      addFavorite () {
        let refCode = formats.getValue(this.loner, ['reference', 'ref'])
        if (refCode) {
          this.$store.dispatch('addFavoriteCompany', {refCode: refCode, tags: this.tags ? this.tags.map(t => t.id) : null})
          this.refreshCompanyProps()
        }
      },
      editNotesDialogOpen: function (item) {
        if (!this.notesEditable) {
          return
        }
        var self = this
        const setNotes = function (data) {
          self.refreshCompanyProps()
        }
        dialogs.register('v-notes-form', vNotesForm)
        var comp = { template: `
          <v-notes-form v-on:input="setNotes" v-on:close="$emit('close')" :fullscreen="fullscreen" :model="model"></v-notes-form>
        `,
          data () {
            return {
              model: {clientCompanyId: self.clientCompanyId, banks: self.banks, company: self.loner, privateNotes: self.privateNotes, notes: self.notes, tags: self.tags, monitoring: self.monitoring},
              setNotes: setNotes,
              fullscreen: self.$vuetify.breakpoint.xsOnly
            }
          }
        }
        dialogs.modal(comp)
      },
      renderCompanyFlags () {
        console.log('renderCompanyFlags', this.loner)
        return this.loner ? this.renderFlags(this.loner.flags, false) : null
      },
      goDepo: function () {
        let tag = `#${formats.getValue(this.loner, ['reference', 'ref'])}`
        this.$router.push({path: '/doc_list/root', query: {tag: [tag]}})
      },
      createButton (caption, icon, hint, action) {
        var template = ''.concat(
          `<v-tooltip top open-delay="500">
              <div slot="activator">
                <v-btn flat  @click="action">
                  <v-icon left>{{icon}}</v-icon>{{caption}}
                </v-btn>
              </div>
              <span>{{hint}}</span>
            </v-tooltip>`
        )
        return {
          template: template,
          data: function () {
            return {
              caption: caption,
              icon: icon,
              hint: hint,
              action: action
            }
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LonerPage.vue?faad039c